export function PlanSkeleton() {
    function render() {
      return /*html*/ `
        <!-- Card: Free -->
        <div class="flex flex-col h-full text-center md:border-r border-gray-200 dark:border-neutral-700">
          <div class="bg-white pt-9 pb-5 px-6 dark:bg-neutral-900 md:border-b border-gray-200 dark:border-neutral-700">
            <!-- Skeleton for title -->
            <div class="h-6 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-24 mx-auto"></div>
          </div>

          <div class="h-[82px] bg-white dark:bg-neutral-900 md:border-b border-gray-200 dark:border-neutral-700 flex justify-center items-center">
            <!-- Skeleton for price -->
            <div class="h-10 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28 mx-auto"></div>
          </div>

          <div class="bg-white flex justify-center pt-10 px-6 dark:bg-neutral-900">
            <ul class="space-y-2.5 w-full flex flex-col items-center min-h-[350px]">
              <!-- Skeleton for list items -->
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-20"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-32"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-20"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-32"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-20"></li>
            </ul>
          </div>

          <div class="bg-white py-8 px-4 dark:bg-neutral-900 hs-tooltip">
            <!-- Skeleton for button -->
            <div class="h-[46px] bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-full"></div>
          </div>
        </div>

        <!-- Card: Enterprise -->
        <div class="flex flex-col h-full text-center md:border-r border-gray-200 dark:border-neutral-700">
          <div class="bg-white pt-9 pb-5 px-6 dark:bg-neutral-900 md:border-b border-gray-200 dark:border-neutral-700">
            <!-- Skeleton for title -->
            <div class="h-6 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-24 mx-auto"></div>
          </div>

          <div class="h-[82px] bg-white dark:bg-neutral-900 md:border-b border-gray-200 dark:border-neutral-700 flex justify-center items-center">
            <!-- Skeleton for price -->
            <div class="h-10 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28 mx-auto"></div>
          </div>

          <div class="bg-white flex justify-center pt-10 px-6 dark:bg-neutral-900">
            <ul class="space-y-2.5 w-full flex flex-col items-center min-h-[350px]">
              <!-- Skeleton for list items -->
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-20"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-32"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-20"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-32"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-20"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-32"></li>
            </ul>
          </div>

          <div class="bg-white py-8 px-4 dark:bg-neutral-900 hs-tooltip">
            <!-- Skeleton for button -->
            <div class="h-[46px] bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-full"></div>
          </div>
        </div>

        <div class="flex flex-col h-full text-center md:border-r border-gray-200 dark:border-neutral-700">
          <div class="bg-white pt-9 pb-5 px-6 dark:bg-neutral-900 md:border-b border-gray-200 dark:border-neutral-700">
            <!-- Skeleton for title -->
            <div class="h-6 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-24 mx-auto"></div>
          </div>

          <div class="h-[82px] bg-white dark:bg-neutral-900 md:border-b border-gray-200 dark:border-neutral-700 flex justify-center items-center">
            <!-- Skeleton for price -->
            <div class="h-10 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28 mx-auto"></div>
          </div>

          <div class="bg-white flex justify-center pt-10 px-6 dark:bg-neutral-900">
            <ul class="space-y-2.5 w-full flex flex-col items-center min-h-[350px]">
              <!-- Skeleton for list items -->
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-20"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-32"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-20"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-32"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-20"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-32"></li>
            </ul>
          </div>

          <div class="bg-white py-8 px-4 dark:bg-neutral-900 hs-tooltip">
            <!-- Skeleton for button -->
            <div class="h-[46px] bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-full"></div>
          </div>
        </div>

        <div class="flex flex-col h-full text-center">
          <div class="bg-white pt-9 pb-5 px-6 dark:bg-neutral-900 md:border-b border-gray-200 dark:border-neutral-700">
            <!-- Skeleton for title -->
            <div class="h-6 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-24 mx-auto"></div>
          </div>

          <div class="h-[82px] bg-white dark:bg-neutral-900 md:border-b border-gray-200 dark:border-neutral-700 flex justify-center items-center">
            <!-- Skeleton for price -->
            <div class="h-10 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28 mx-auto"></div>
          </div>

          <div class="bg-white flex justify-center pt-10 px-6 dark:bg-neutral-900">
            <ul class="space-y-2.5 w-full flex flex-col items-center min-h-[350px]">
              <!-- Skeleton for list items -->
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-20"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-32"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-20"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-32"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-20"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-32"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-20"></li>
              <li class="h-4 bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-28"></li>
            </ul>
          </div>

          <div class="bg-white py-8 px-4 dark:bg-neutral-900 hs-tooltip">
            <!-- Skeleton for button -->
            <div class="h-[46px] bg-gray-200 rounded dark:bg-neutral-700 animate-pulse w-full"></div>
          </div>
        </div>
      `;
    }
  
    return { render };
  }
  